import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">平台优势</h2>
          <p className="text-foreground-500 text-sm md:text-base">为什么千万吃瓜群众选择五一黑料网</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((feature, i) => (
            <div
              key={feature.id}
              className="p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all text-center group animate-fade-in-up"
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${feature.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}